import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {useInterval, updateUTCDate, showToast} from '../../common/app_common.js';
import {PageNation} from '../../common/component_common.js';
import {getApiSitesCount, getApiSites, putApiSitesSiteEdgeId} from '../../common/fetch_api/site'
import {getApiEdgeCount, getApiEdge, getApiEdgeId, putApiEdgeIdStatus} from '../../common/fetch_api/edge'
import {BsExclamationCircle, BsChevronExpand} from 'react-icons/bs'
import {EdgeInfoModal} from './modals';
import {DecideWindow} from '../../common/modal_common.js';

const PAGE_PER = 16;

export const View = ({addEdgeInfo, runUpdateTab, setUpdateTab}) => {
    
    const [update, setUpdate] = useState(false);

    const [tableSpinner, setTableSpinner] = useState(false);
    const [pendingEdgeList, setPendingEdgeList] = useState(null);

    const [edgeSelCount, setEdgeSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);
    const setPageMove = (e) => {
        setCurPageState(e);
        runUpdate();
    }
    
    const [edgeInfoId, setEdgeInfoId] = useState(null);
    
    const sortInfo = useRef({title:'', order:''});
    
    const [modalEdgeInfo, setModalEdgeInfo] = useState(false);
    const closeModalEdgeInfo = () => setModalEdgeInfo(false);
    const showModalEdgeInfo = (edgeId) => {
        setEdgeInfoId(edgeId);
        setModalEdgeInfo(true);
    }
    
    const acceptSite = useRef('');
    const [decideAction, setDecideAction] = useState('');
    const [decideBody, setDecideBody] = useState(null);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (action) =>
    {
        setDecideAction(action);

        let reject = false;
        if( action === 'reject')
        {
            reject = true;
        }

        let result = checkEdgeId(reject);

        if( result.edgeId.length < 1 )
        {
            if( !result.err )
            {
                showToast("Please Check the items", "warning");
            }
            return;
        }
        
        if( action === 'accept')
        {
            Promise.resolve( getApiSitesCount('', '') )
            .then( data => {
                if( data)
                {
                    Promise.resolve( getApiSites(data.count, 1, '', '', 'name', 'asc') )
                    .then( siteArr => {
                        
                        const siteList = siteArr.map( (site, index) =>
                            <option key={index} value={site.site}>{site.site}</option>
                        );

                        setDecideBtn('Accept');
                        setDecideBody(
                            <div>
                                <p className='text-center'>Would you like to add Edge to this site?</p>
                                <div className="d-flex">
                                    <div className="col-3 label-box">Callsign</div>
                                    <div className="col-9">
                                        {addEdgeInfo!==''
                                        ?
                                            <input className="form-control input-box" type="text" value={addEdgeInfo} ref={acceptSite} readOnly/>
                                        :
                                            <select className="form-select form-select-sm" ref={acceptSite}>
                                                <option value=''>--- Select Callsign ---</option>
                                                {siteList}
                                            </select>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                        
                        // acceptSite.current.value = addEdgeInfo;
                    });
                }
            });
        }
        else if( action === 'dismiss' )
        {
            setDecideBtn('Dismiss');
            setDecideBody(
                <div className='text-center'>
                    <p>Would you like to dismiss this Edge?</p>
                    <p>The dismissed Edge will be removed from the Pending.</p>
                </div>
            );
        }
        else if( action === 'reject' )
        {
            setDecideBtn('Reject');
            setDecideBody(
                <div className='text-center'>
                    <p>Would you like to reject this Edge?</p>
                    <p>The rejected Edge will be moved to Reject.</p>
                </div>
            );
        }
        
        setModalDecide(true);
    }
    
    const onClickAction = (is) => {
        if( is )
        {
            let result = checkEdgeId(false);
            let apiArr = [];
            
            if(decideAction === 'accept')
            {
                apiArr = setEdgeMove(result.edgeId);
            }
            else if(decideAction === 'dismiss')
            {
                apiArr = setEdgeStatus('dismiss', result.edgeId);
            }
            else if(decideAction === 'reject')
            {
                apiArr = setEdgeStatus('reject', result.edgeId);
            }
                
            Promise.all(apiArr)
            .then( done => {
                checkClear();
                runUpdate();
                setUpdateTab();
            })
            .catch( err => {
                // console.log('err');
            });
        }
    }

    function setEdgeMove(edgeArr)
    {
        let apiArr = [];
        for( let edgeId of edgeArr)
        {
            if( addEdgeInfo !== '' )
            {
                apiArr.push( putApiSitesSiteEdgeId(addEdgeInfo, edgeId) );
            }
            else
            {
                apiArr.push( putApiSitesSiteEdgeId(acceptSite.current.value, edgeId) );
            }
        }

        return apiArr;
    }

    function setEdgeStatus(status, edgeArr)
    {
        let apiArr = [];
        for( let edgeId of edgeArr)
        {
            apiArr.push( putApiEdgeIdStatus(status, edgeId) );
        }

        return apiArr;
    }

    // const checkOne = () => {
    //     const checkBox = Array.from(document.getElementsByClassName('form-check-input'));
    //     const checkAll = [...checkBox].filter( (item) => {return item.id === 'checkAll' })[0];
    //     const temp = [...checkBox].filter( (item) => {return item.id !== 'checkAll'});
    //     const checkTrue = [...temp].filter( (item) => {return item.checked === true }).length;
    //     const checkTotal = temp.length;

    //     if( checkAll.checked === true && checkTrue < checkTotal)
    //     {
    //         checkAll.checked = false;
    //     }
    //     else if( checkAll.checked === false && checkTrue >= checkTotal)
    //     {
    //         checkAll.checked = true;
    //     }
    // }

    const checkAll = (e) => {
        const checkBox = Array.from(document.getElementsByClassName('form-check-input'));

        let checked = false;
        if( e.target.checked === true )
        {
            checked = true;
        }

        checkBox.forEach(function(item) {
            item.checked = checked;
        });
    }

    const checkClear = () => {
        const checkBox = Array.from(document.getElementsByClassName('form-check-input'));

        checkBox.forEach(function(item) {
            item.checked = false;
        });
    }
    
    const checkEdgeId = (isReject) => {
        let tbody = document.getElementById('pendingTbody').childNodes;
        let edgeId = [];
        let err = false;
    
        tbody.forEach(function(tr) {
            if( (tr.firstChild.firstChild).checked === true )
            {
                if(isReject)
                {
                    if( tr.getAttribute('collect-type') === 'pull' )
                    {
                        err = true;
                        tr.firstChild.firstChild.checked = false;                        
                        showToast(`'Collect Pull' Devices cannot be rejected - ${tr.childNodes[4].textContent}`, "error");
                        return;
                    }
                }
                
                edgeId.push( tr.id);
            }
        });
    
        return {'edgeId':edgeId, 'err':err};
    }

    function getEdgeInitial(type)
    {
        if( type === 'm-agent' ) return 'M';
        if( type === 's-agent' ) return 'S';
        if( type === 'r-agent' ) return 'R';
        return 'T';
    }

    function getCheckInTime(sec)
    {
        let checkIn = new Date(0);
        checkIn.setUTCSeconds(sec);
        
        return checkIn;
    }

    const PendingTbody = ({edge, curTime}) => {
        const [isChecked, setIsChecked] = useState(false);
        
        const handleClick = (e) => {
            setIsChecked(!isChecked);
        };
        
        return  (
            <tr id={edge.id} collect-type={edge.collectType} onClick={handleClick}>
                <td><input className="form-check-input" type="checkbox" checked={isChecked} onChange={() => {}} /></td>
                <td><div className="edge-box edge-default"><span className="edge-item">{getEdgeInitial(edge.type)}</span></div></td>
                <td title={edge.id}>{edge.id}</td>
                <td title={edge.fingerprint}>{edge.fingerprint}</td>
                <td title={edge.name}>{edge.name}</td>
                <td className={`${(curTime.getTime() - getCheckInTime(edge.sec).getTime()) >= 60000? "text-warning":""}`}
                    title={updateUTCDate(getCheckInTime(edge.sec))}>{updateUTCDate(getCheckInTime(edge.sec))}</td>
                <td title={edge.clientIp}>{edge.clientIp}</td>
                <td>
                    <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Details" onClick={() => {showModalEdgeInfo(edge.id);}}><BsExclamationCircle/></Button>
                </td>
            </tr>
        )
    }

    const getEdges = () => {
        Promise.resolve( getApiEdgeCount('pending') )
        .then( data => {
            if(data && data.count > 0)
            {
                setEdgeSelCount(data.count);

                curPageRef.current.value = Math.min(Math.ceil(data.count/PAGE_PER), curPageState);
                setCurPageState(parseInt(curPageRef.current.value));


                Promise.resolve( getApiEdge('pending', PAGE_PER, curPageRef.current.value, sortInfo.current.title, sortInfo.current.order) )
                .then( idArr => {
                    let apiArr = [];
                    for( let id of idArr )
                    {
                        if( id.length > 1)
                        {
                            apiArr.push( getApiEdgeId(id) );
                        }
                    }

                    Promise.all( apiArr )
                    .then( edgeArr => {
                        
                        // edgeArr.sort((a, b) => strArraySortAsc(a.name.toLowerCase(), b.name.toLowerCase()));

                        let curTime = new Date();
                        setPendingEdgeList( edgeArr.map( (edge, idx) => (
                            <PendingTbody key={edge.id}  edge={edge} curTime={curTime} />
                        )));

                        setTimeout(() => {setTableSpinner(false);}, 700);
                    })
                    .catch( e => {
                        setTimeout(() => {setTableSpinner(false);}, 700);
                    });
                })
                .catch( e => {
                    setTimeout(() => {setTableSpinner(false);}, 700);
                });
            }
            else
            {
                setPendingEdgeList([]);
                curPageRef.current.value = 1;
                setCurPageState(1);
                setEdgeSelCount(1);
                setTimeout(() => {setTableSpinner(false);}, 700);
            }
        })
        .catch( e => {
            setTimeout(() => {setTableSpinner(false);}, 700);
        });
    };
    
    function toggleSort(title)
    {
        checkClear();

        let curTitle = sortInfo.current.title;
        let curOrder = sortInfo.current.order;

        if( curTitle === title )
        {
            if( curOrder === 'asc' )
            {
                curOrder = 'desc';
            }
            else
            {
                curOrder = 'asc';
            }
        }
        else
        {
            curTitle = title;
            curOrder = 'asc';
        }

        sortInfo.current = {title: curTitle, order: curOrder};

        getEdges();
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        setTableSpinner(true);
        getEdges();
    }, [update, curPageState, runUpdateTab]);

    // useInterval(() =>
    // {
    //     runUpdate();
    // }, 30000 );

    return (
        <>
            <div className="d-flex justify-content-end mt-2 me-2">
                <Button variant="primary" className="btn btn-sm" onClick={() => {showModalDecide('accept')}}>Accept</Button>
                <Button variant="danger" className="btn btn-sm ms-2" onClick={() => {showModalDecide('dismiss')}}>Dismiss</Button>
                <Button variant="danger" className="btn btn-sm ms-2" onClick={() => {showModalDecide('reject')}}>Reject</Button>
            </div>
            <div className="section pending-area position-relative mt-2">
                {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th><input className="form-check-input" id='checkAll' type="checkbox" onClick={checkAll}/></th>
                            <th className="sorting" onClick={() => {toggleSort('type');}}>Type<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('id');}}>EdgeId<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('fingerprint');}}>Fingerprint<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('name');}}>Name<BsChevronExpand /></th>
                            <th>Latest Check in</th>
                            <th>Client IP</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody id='pendingTbody'>
                        {pendingEdgeList}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setPageMove}
                selCount={edgeSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            {modalEdgeInfo&&<EdgeInfoModal edgeId={edgeInfoId} show={modalEdgeInfo} handleClose={closeModalEdgeInfo}></EdgeInfoModal>}
            {modalDecide&&<DecideWindow result={onClickAction} show={modalDecide} handleClose={closeModalDecide} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        </>
    )
}